import React from 'react';
import './Cali.css'; 

const Pereira = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
      <h1><a className='Titulo' href="/aip/SKPE.pdf" target="_blank" rel="noreferrer">Aeropuerto Matecaña</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 08</th>                      
          </tr>  
         <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/PEI5A.pdf" target="_blank" rel="noreferrer">PEI5A</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPE/NEBO2A.pdf" target="_blank" rel="noreferrer">NEBO2A</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPE/TOLI2C.pdf" target="_blank" rel="noreferrer">TOLI2C</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPE/TOLI2C.pdf" target="_blank" rel="noreferrer">TORO2F</a></th>
          </tr>
                
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 26</th>                      
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPE/IRIG3E.pdf" target="_blank" rel="noreferrer">IRIG3E</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPE/AKSI3B.pdf" target="_blank" rel="noreferrer">AKSI3B</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPE/AKSI3B.pdf" target="_blank" rel="noreferrer">MATR5B</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPE/AXM6B.pdf" target="_blank" rel="noreferrer">AXM6B</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPE/AXM6B.pdf" target="_blank" rel="noreferrer">IRIG4B</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPE/NEBO3B.pdf" target="_blank" rel="noreferrer">NEBO3B</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPE/TOLI2D.pdf" target="_blank" rel="noreferrer">TOLI2D</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPE/TOLI2D.pdf" target="_blank" rel="noreferrer">TORO2H</a></th>
          </tr>
          
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 08</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/AKSI3A.pdf" target="_blank" rel="noreferrer">AKSI3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/IRIG3D.pdf" target="_blank" rel="noreferrer">IRIG3D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ISNO2B.pdf" target="_blank" rel="noreferrer">ISNO2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/AKSI2G.pdf" target="_blank" rel="noreferrer">AKSI2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/AKSI2G.pdf" target="_blank" rel="noreferrer">MZL2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/AKSI2G.pdf" target="_blank" rel="noreferrer">MATR2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/AKSI2G.pdf" target="_blank" rel="noreferrer">UIB2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ISNO2C.pdf" target="_blank" rel="noreferrer">ISNO2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ISNO2C.pdf" target="_blank" rel="noreferrer">TORO2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ISNO2C.pdf" target="_blank" rel="noreferrer">AXM2K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ISNO2E.pdf" target="_blank" rel="noreferrer">ISNO2E</a></th>
          </tr>
           
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 26</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/AKSI3A.pdf" target="_blank" rel="noreferrer">AKSI3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/IRIG3D.pdf" target="_blank" rel="noreferrer">IRIG3D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ISNO2B.pdf" target="_blank" rel="noreferrer">ISNO2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/AKSI2G.pdf" target="_blank" rel="noreferrer">AKSI2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/AKSI2G.pdf" target="_blank" rel="noreferrer">MZL2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/AKSI2G.pdf" target="_blank" rel="noreferrer">MATR2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/AKSI2G.pdf" target="_blank" rel="noreferrer">UIB2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ISNO1C.pdf" target="_blank" rel="noreferrer">ISNO2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ISNO2C.pdf" target="_blank" rel="noreferrer">TORO2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ISNO2C.pdf" target="_blank" rel="noreferrer">AXM2K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ISNO2E.pdf" target="_blank" rel="noreferrer">ISNO2E</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 08</th>                      
          </tr>   
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ILSX08.pdf" target="_blank" rel="noreferrer">ILS X</a></th>
          </tr>   
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ILSY08.pdf" target="_blank" rel="noreferrer">ILS Y</a></th>
          </tr>    
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ILSZ08.pdf" target="_blank" rel="noreferrer">ILS Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/RNPW08.pdf" target="_blank" rel="noreferrer">RNP W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/RNPX08.pdf" target="_blank" rel="noreferrer">RNP X</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/RNPY08.pdf" target="_blank" rel="noreferrer">RNP Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/RNPZ08.pdf" target="_blank" rel="noreferrer">RNP Z</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ILSY08.pdf" target="_blank" rel="noreferrer">LOC Y</a></th>
          </tr>         
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/ILSZ08.pdf" target="_blank" rel="noreferrer">LOC Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/VOR08.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 26</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/RNPY26.pdf" target="_blank" rel="noreferrer">RNP Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/RNPZ26.pdf" target="_blank" rel="noreferrer">RNP Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPE/RNPAR26.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Pereira;